<script setup lang="ts"></script>

<template>
  <div class="bg-white rounded-3xl p-3 xl:p-6">
    <slot name="content" />
  </div>
</template>

<style scoped></style>
